var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1532.757 491.984c0 5.9-8.846 16.218-8.846 16.218s-8.846-10.321-8.846-16.218a8.846 8.846 0 0 1 17.693 0z",
    transform: "translate(-1485.051 -451.497)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.86,
    cy: 40.487,
    r: 3.686
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1491.809 462.51c0 5.16-7.372 14.007-7.372 14.007s-7.372-8.846-7.372-14.007a7.372 7.372 0 1 1 14.744 0z",
    transform: "translate(-1475.064 -444.138)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.373,
    cy: 18.372,
    r: 2.949
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1508.027 508.465h-23.59a7.393 7.393 0 0 1 -7.372-7.372 7.393 7.393 0 0 1 7.372-7.372h11.426a4.806 4.806 0 0 0 4.792-4.792 4.806 4.806 0 0 0 -4.792-4.792h-6.263",
    transform: "translate(-1475.064 -451.76)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.704b564b1e4f731322c24aca522313c2.svg";
export { ForwardRef as ReactComponent };